import linkifyIt from "linkify-it";
import tlds from "tlds/index.json";
const linkify = linkifyIt();
linkify.tlds(tlds).add("ftp:", null).set({
    fuzzyEmail: false
}).set({
    fuzzyIP: false
});
export default linkify;
